module.exports = __webpack_public_path__ + "static/assets/9d94fd8ff8477c6f550e9410f25ddddc.svg";